/** @format */

import Template from "../../component/Template.js";
import { useEffect, useRef } from "react";
import Api from "../../component/Api";
import { useState } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../../component/useAuth.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import SchoolIcon from "@mui/icons-material/School";

import ArrowForwardIcon from "@mui/icons-material/ForwardToInbox";
import ArrowForwardIcon2 from "@mui/icons-material/ArrowForward";

import UndoIcon from "@mui/icons-material/Undo";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

import "datatables.net";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Select from "react-select";
import $ from "jquery";
import { Download } from "@mui/icons-material";

export default function SFACondonation() {
  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/sfa/");
  }
  let cid = localStorage.getItem("collegeid");

  const tableRef = useRef(null);

  const [loading, setlodaing] = useState(false);
  const { http } = Api();
  const [admissionYears, setAdmissionYears] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [selectedDiscipline, setSelectedDiscipline] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableLoaded, setTableLoaded] = useState(false); // to know if Go was clicked

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [currentStudent, setCurrentStudent] = useState(null);
  const [condonationStatus, setCondonationStatus] = useState({});
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [eventStatus, setEventStatus] = useState(null);
  const [stats, setStats] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [totalHours, setTotalHours] = useState(0);

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get("/Admin/getActiveAdmissionYear");
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year,
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears();
  }, []);

  useEffect(() => {
    const fetchDisciplines = async () => {
      try {
        if (selectedYear && selectedSemester) {
          const response = await http.get(`/College/getSFADisciplines`, {});
          const data = response.data.map((d) => ({
            value: d.id + "-" + d.college_course_type,
            label: d.discipline_name + "-" + d.college_course_type,
          }));
          setDisciplines(data);
        }
      } catch (error) {
        console.error("Error fetching disciplines:", error);
      }
    };

    fetchDisciplines();
  }, [selectedYear, selectedSemester]); //  run again whenever year or sem changes

  const handleGo = async () => {
    try {
      if (!selectedYear || !selectedSemester || !selectedDiscipline) {
        toast.error("Please select all filters");
        return;
      }

      const response = await http.get("/College/getSFAStudentsList", {
        params: {
          admissionyear: selectedYear.value,
          semester: selectedSemester.value,
          discipline_id: selectedDiscipline.value,
        },
      });

      const studentsArray = Object.values(response.data.students);
      setTableData(studentsArray);
      setFilteredData(studentsArray);

      setEventStatus(response.data.event_status);
      setTableLoaded(true); // mark that Go was clicked

      // Fetch statistics
      const statsResponse = await http.get(
        "/College/getCondonationStatisticsSFA",
        {
          params: {
            admissionyear: selectedYear.value,
            semester: selectedSemester.value,
            discipline_id: selectedDiscipline.value,
          },
        }
      );

      if (statsResponse.data.statisticsData?.length > 0) {
        setStats(statsResponse.data.statisticsData[0]);
      } else {
        setStats(null);
      }
    } catch (error) {
      console.error("Error fetching condonation data:", error);
      toast.error("Verified Student List not Available");
      setTableData([]);
      setTableLoaded(true);
    }
  };

  const handleStatusChange = (studentId, courseId, value) => {
    setCondonationStatus((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [courseId]: value,
      },
    }));
  
    // If NOT condonation → clear HH and MM using updateCourse
    if (value !== "condonation") {
      updateCourse(courseId, {
        condonation_hours: 0,
        condonation_minutes: 0,
      });
    }
  };
  

  const handleOpenModal = (student, course) => {
    setCurrentStudent(student);
    setCurrentCourse(course);

    const total = student.courses.reduce((sum, c) => {
      return (
        sum +
        (c.exam_reg_status === "condonation"
          ? Number(c.condonation_hours || 0)
          : 0)
      );
    }, 0);
    setTotalHours(total);

    // Prefill condonation status from DB values
    setCondonationStatus((prev) => {
      const updated = { ...prev };

      if (!updated[student.accountid]) {
        updated[student.accountid] = {};
      }

      student.courses.forEach((c) => {
        updated[student.accountid][c.course_id] =
          c.exam_reg_status && c.exam_reg_status !== ""
            ? c.exam_reg_status
            : "eligible"; // default if not present
      });

      return updated;
    });

    setShowModal(true);
  };

  const handleSaveStatus = async () => {
    if (currentStudent) {
      let totalCondonationMinutes = 0;

      const courseStatuses = {};

      for (const course of currentStudent.courses) {
        const status =
          condonationStatus[currentStudent.accountid]?.[course.course_id] ||
          "eligible";

        courseStatuses[course.course_id] = status;

        if (status === "condonation") {
          const h = Number(course.condonation_hours || 0);
          const m = Number(course.condonation_minutes || 0);

          if (h === 0 && m === 0) {
            toast.error("Please enter condonation hours and minutes");
            return;
          }

          totalCondonationMinutes += h * 60 + m;
        }
      }

      if (totalCondonationMinutes > 50 * 60) {
        toast.error("Total condonation hours cannot exceed 50 hours");
        return;
      }

      try {
        await http.post("/College/saveCondonation", {
          student_id: currentStudent.accountid,
          statuses: courseStatuses,

          // FIX: COMBINE HOURS + MINUTES BEFORE SENDING
          condonation_hours: currentStudent.courses.reduce((acc, c) => {
            const h = Number(c.condonation_hours || 0);
            const m = Number(c.condonation_minutes || 0);
            const totalMinutes = h * 60 + m;
            acc[c.course_id] = toHMM(totalMinutes);
            return acc;
          }, {}),

          semester: selectedSemester.value,
        });

        toast.success("Forwarded to Principal Successfully");
        handleGo();
      } catch (err) {
        toast.error("Failed to save condonation status");
      }
    }

    setShowModal(false);
  };

  const updateCourse = (courseId, updatedFields) => {
    const updatedCourses = currentStudent.courses.map((c) =>
      c.course_id === courseId ? { ...c, ...updatedFields } : c
    );

    setCurrentStudent((prev) => ({
      ...prev,
      courses: updatedCourses,
    }));

    // 🔥 Calculate total condonation hours (convert HH:MM → hours)
    const totalMinutes = updatedCourses.reduce((sum, c) => {
      if (
        condonationStatus[currentStudent.accountid]?.[c.course_id] ===
        "condonation"
      ) {
        const h = Number(c.condonation_hours || 0);
        const m = Number(c.condonation_minutes || 0);
        return sum + (h * 60 + m);
      }
      return sum;
    }, 0);

    setTotalHours(totalMinutes); // store in minutes
  };

  const toHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h}.${String(m).padStart(2, "0")}`;
  };

  const formatHHMM = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const handleCheckboxChange = (student) => {
    setSelectedStudents((prev) => {
      if (prev.find((s) => s.accountid === student.accountid)) {
        // remove if already selected
        return prev.filter((s) => s.accountid !== student.accountid);
      } else {
        // add new
        return [...prev, student];
      }
    });
  };

  const handleForward = async (students) => {
    try {
      if (!Array.isArray(students)) {
        students = [students]; // wrap single student into array
      }

      const payload = {
        students: students.map((s) => ({
          accountid: s.accountid,
          courses: s.courses,
        })),
        semester: selectedSemester?.value, // send semester if needed
      };

      const response = await http.post("/College/forwardCondonation", payload);

      console.log("Forward response:", response.data);
      toast.success("Forward successful");
      handleGo();
      setSelectedStudents([]); // reset after forward
    } catch (err) {
      console.error("Forward error:", err);
      toast.error("Failed to forward");
    }
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
    }),

    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      "&::-webkit-scrollbar": {
        width: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        {loading ? (
          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div
                    className="card-body d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px" }}
                  >
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>Condonation/Not Eligible List</h5>
                      </div>
                    </div>
                    <div className="card-body pdg">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-3">
                            <label>
                              Admission Year <span className="errorclr">*</span>
                            </label>
                            <Select
                              maxMenuHeight={200}
                              menuPlacement="auto"
                              id="admyear"
                              name="admyear"
                              className="form"
                              styles={customStyles}
                              options={admissionYears}
                              value={selectedYear}
                              onChange={setSelectedYear}
                            />
                          </div>

                          <div className="col-md-3">
                            <label>
                              Semester <span className="errorclr">*</span>
                            </label>
                            <Select
                              maxMenuHeight={200}
                              menuPlacement="auto"
                              id="semester_id"
                              name="semester_id"
                              className="form"
                              styles={customStyles}
                              options={[
                                { value: 1, label: "1" },
                                { value: 2, label: "2" },
                                { value: 3, label: "3" },
                                { value: 4, label: "4" },
                                { value: 5, label: "5" },
                                { value: 6, label: "6" },
                                { value: 7, label: "7" },
                                { value: 8, label: "8" },
                              ]}
                              value={selectedSemester}
                              onChange={setSelectedSemester}
                            />
                          </div>

                          <div className="col-md-3">
                            <label>
                              Discipline <span className="errorclr">*</span>
                            </label>
                            <Select
                              id="discipline_id"
                              name="discipline_id"
                              className="form"
                              styles={customStyles}
                              options={disciplines}
                              value={selectedDiscipline}
                              onChange={setSelectedDiscipline}
                            />
                          </div>

                          <div className="col-md-3 d-flex align-items-end">
                            <button
                              type="button"
                              className="btn btn-primary action-btn w-10"
                              onClick={handleGo}
                            >
                              Go
                            </button>
                          </div>
                        </div>

                        {/* for shoiwng statistics */}
                        {stats && (
                          <div className="mb-4">
                            <div className="table-container table-responsive">
                              <table className="display dataTable table-striped table-bordered ex-v-table">
                                <thead>
                                  <tr>
                                    <th>Total Students</th>
                                    {/* <th>Draft</th> */}
                                    <th>Forwarded to Principal</th>
                                    <th>Forwarded to Student</th>
                                    <th>Application Submitted by student</th>
                                    <th>Forwarded to University</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{stats.total_registrations}</td>
                                    {/* <td>{stats.draft_count}</td> */}
                                    <td>{stats.sfa_fwd_count}</td>
                                    <td>{stats.fwd_stud_count}</td>
                                    <td>{stats.stud_paid_count}</td>
                                    <td>{stats.fwd_unvty_count}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}

                        <div className="mt-4">
                          {selectedStudents.length > 0 && (
                            <div className="mb-3">
                              <button
                                className="btn btn-success"
                                onClick={() => handleForward(selectedStudents)} // pass array
                              >
                                Forward Selected ({selectedStudents.length})
                              </button>
                            </div>
                          )}
                          {/*  Search box */}
                          <div className="d-flex justify-content-end mb-3">
                            <input
                              type="text"
                              placeholder="Search by PRN or Name"
                              className="form-control w-25"
                              value={searchTerm}
                              onChange={(e) => {
                                const value = e.target.value.toLowerCase();
                                setSearchTerm(value);
                                const filtered = tableData.filter(
                                  (student) =>
                                    student.prn.toLowerCase().includes(value) ||
                                    student.studentname
                                      .toLowerCase()
                                      .includes(value)
                                );
                                setFilteredData(filtered);
                              }}
                            />
                          </div>
                          <div className="table-container table-responsive">
                            <table className="display dataTable table-striped table-bordered ex-v-table">
                              <thead>
                                <tr className="bg-primary">
                                  {/* <th scope="col">Select</th> */}
                                  <th scope="col">PRN/Apaar No</th>
                                  <th scope="col">Name</th>
                                  <th scope="col">Courses</th>
                                  <th scope="col">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!tableLoaded ? (
                                  <tr>
                                    <td colSpan="6" className="text-center">
                                      No data available
                                    </td>
                                  </tr>
                                ) : tableData.length === 0 ? (
                                  <tr>
                                    <td colSpan="6" className="text-center">
                                      No records found
                                    </td>
                                  </tr>
                                ) : (
                                  filteredData.map((student, index) => (
                                    <tr key={student.accountid}>
                                      {/* <td className="text-center">
                                        {student.has_draft == 1 ? (
                                          <input
                                            type="checkbox"
                                            checked={selectedStudents.some(
                                              (s) =>
                                                s.accountid ===
                                                student.accountid
                                            )}
                                            onChange={() =>
                                              handleCheckboxChange(student)
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </td> */}
                                      <td>
                                        {student.prn}
                                        <br />
                                        {student.apaar_no}
                                      </td>
                                      <td>{student.studentname}</td>

                                      <td data-label="Courses">
                                        <div className="treeview">
                                          <ul>
                                            {student.courses.map(
                                              (course, index) => (
                                                <li key={index}>
                                                  {course.course_code} :{" "}
                                                  {course.course_name}{" "}
                                                  <span
                                                    className={`badge rounded-pill text-white ${
                                                      course.exam_reg_status ===
                                                        "eligible" ||
                                                      !course.exam_reg_status
                                                        ? "bg-success"
                                                        : course.exam_reg_status ===
                                                          "ineligible"
                                                        ? "bg-danger"
                                                        : "bg-warning"
                                                    }`}
                                                  >
                                                    {course.exam_reg_status
                                                      ? course.exam_reg_status
                                                      : "eligible"}
                                                  </span>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      </td>
                                      <td className="text-center">
                                        {eventStatus === "active" &&
                                        student.flag_modify_fwd === 1 ? (
                                          <>
                                            <button
                                              className="btn bg-primary  w-100 w-md-auto text-nowrap text-white"
                                              onClick={() =>
                                                handleOpenModal(
                                                  student,
                                                  student.courses
                                                )
                                              }
                                            >
                                              Modify & Forward
                                            </button>

                                            {/* {student.has_draft == 1 && (
                                            <button
                                              className="btn btn-sm btn-outline-success mt-2"
                                              onClick={() =>
                                                handleForward(student)
                                              }
                                            >
                                              Forward
                                            </button>
                                          )} */}
                                          </>
                                        ) : (
                                          student.show_status && (
                                            <span className="status-label text-success fw-bold">
                                              {student.show_status}
                                            </span>
                                          )
                                        )}
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>

      {/* Modal */}
      {showModal && currentStudent && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div
            className="modal-dialog  modal-dialog-centered modal-dialog-scrollable"
            style={{
              width: "45vw",
              maxWidth: "none",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title">
                    {currentStudent.studentname} - {currentStudent.prn}
                  </h5>

                  {currentStudent.eligible_for_condonation === 0 && (
                    <div className="d-flex align-items-center text-danger fw-bold mt-2">
                      <i className="bi bi-info-circle me-2"></i>
                      <small>Condonation Already Availed</small>
                    </div>
                  )}
                </div>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="table-responsive">
                  <table className="table table-bordered table-striped text-center ex-v-table">
                    <thead>
                      <tr className="bg-primary text-white">
                        <th style={{ width: "40%" }} className="fw-bold ">
                          Course
                        </th>
                        {/* <th>Course Name</th> */}
                        <th style={{ width: "15%" }} className="fw-bold">
                          Eligible for Exam
                        </th>
                        <th style={{ width: "15%" }} className="fw-bold">
                          Eligible with Condonation
                        </th>
                        <th style={{ width: "15%" }} className="fw-bold">
                          Not Eligible
                        </th>
                        <th style={{ width: "15%" }} className="fw-bold">
                          Condonation Hours
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentStudent.courses.map((course, index) => (
                        <tr key={index} style={{ lineHeight: "1.2" }}>
                          <td>
                            {course.course_code}- {course.course_name}
                          </td>
                          {/* <td>{course.course_name}</td> */}
                          <td>
                            <input
                              type="radio"
                              name={`condonation_${course.course_id}`}
                              value="eligible"
                              checked={
                                condonationStatus[currentStudent.accountid]?.[
                                  course.course_id
                                ] === "eligible"
                              }
                              onChange={() =>
                                handleStatusChange(
                                  currentStudent.accountid,
                                  course.course_id,
                                  "eligible"
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="radio"
                              name={`condonation_${course.course_id}`}
                              value="condonation"
                              checked={
                                condonationStatus[currentStudent.accountid]?.[
                                  course.course_id
                                ] === "condonation"
                              }
                              onChange={() =>
                                handleStatusChange(
                                  currentStudent.accountid,
                                  course.course_id,
                                  "condonation"
                                )
                              }
                              disabled={
                                currentStudent.eligible_for_condonation === 0
                              }
                              title={
                                currentStudent.eligible_for_condonation === 0
                                  ? "Condonation not allowed for this student"
                                  : ""
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="radio"
                              name={`condonation_${course.course_id}`}
                              value="ineligible"
                              checked={
                                condonationStatus[currentStudent.accountid]?.[
                                  course.course_id
                                ] === "ineligible"
                              }
                              onChange={() =>
                                handleStatusChange(
                                  currentStudent.accountid,
                                  course.course_id,
                                  "ineligible"
                                )
                              }
                            />
                          </td>
                          <td style={{ display: "flex", gap: "6px" }}>
                            {/* HOURS INPUT */}
                            <input
                              type="number"
                              min="0"
                              className="form-control form-control-sm"
                              style={{ width: "55px" }}
                              placeholder="HH"
                              value={course.condonation_hours || ""}
                              disabled={
                                condonationStatus[currentStudent.accountid]?.[
                                  course.course_id
                                ] !== "condonation" ||
                                currentStudent.eligible_for_condonation === 0
                              }
                              onInput={(e) => {
                                e.target.value = e.target.value.slice(0, 2);
                              }}
                              onChange={(e) => {
                                let h = Number(e.target.value);
                                if (h < 0) h = 0;
                                updateCourse(course.course_id, {
                                  condonation_hours: h,
                                });
                              }}
                            />

                            {/* MINUTES INPUT */}
                            <input
                              type="number"
                              min="0"
                              max="59"
                              className="form-control form-control-sm"
                              style={{ width: "55px" }}
                              placeholder="MM"
                              value={course.condonation_minutes || ""}
                              disabled={
                                condonationStatus[currentStudent.accountid]?.[
                                  course.course_id
                                ] !== "condonation" ||
                                currentStudent.eligible_for_condonation === 0
                              }
                              onChange={(e) => {
                                let m = Number(e.target.value);

                                // prevent entering above 59
                                if (m > 59) m = 59;
                                if (m < 0) m = 0;

                                updateCourse(course.course_id, {
                                  condonation_minutes: m,
                                });
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer flex-wrap">
                {totalHours > 0 && (
                  <div className="fw-bold text-primary">
                    Total Condonation Hours:{" "}
                    <span
                      style={{
                        color: totalHours > 3000 ? "red" : "green",
                      }}
                    >
                      {formatHHMM(totalHours)}
                    </span>{" "}
                    / 50
                  </div>
                )}
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSaveStatus}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
